export default "__VITE_ASSET__bawQ8OEj__"